import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import {
  selectTemplateData,
  selectFirstActiveRoute,
  selectHasActiveSearchers,
} from 'legacyfrontend/redux/selectors/application-selectors';
import BannersComponents from 'legacyfrontend/components/home/BannersComponents';

const { HOME } = ROUTE_KEYS;

const HomeView = () => {
  const history = useHistory();
  const location = useLocation();
  const { onSearchCount } = useGlobal();
  const hasRedirected = useRef(false);

  const templateData = useSelector(selectTemplateData);
  const firstActiveRoute = useSelector(selectFirstActiveRoute);
  const hasActiveSearchers = useSelector(selectHasActiveSearchers);

  useEffect(() => {
    if (
      location.pathname === HOME &&
      onSearchCount === 0 &&
      !hasRedirected.current &&
      templateData &&
      firstActiveRoute !== HOME &&
      hasActiveSearchers
    ) {
      hasRedirected.current = true;
      history.replace(firstActiveRoute);
    }
  }, [
    location.pathname,
    onSearchCount,
    history,
    templateData,
    firstActiveRoute,
    hasActiveSearchers,
  ]);

  if (!hasActiveSearchers) {
    return <BannersComponents />;
  }

  return null;
};

export default HomeView;
